import Col from "@ui-library/grid/Col"
import Row from "@ui-library/grid/Row"
import GridWrapper from "@ui-library/grid/Wrapper"
import { cn } from "@utils/utils"
import { Fragment } from "react"
import Accordion from "./Accordion"
import { AccordionSectionProps } from "./AccordionSectionProps"
import { HideableAccordionItem, TwoColumnsAccordion } from "./TwoColumnsAccordion"

const SingleColumnAccordion = ({ sections }: Pick<AccordionSectionProps, "sections">) => (
  <Accordion type="single">
    {sections?.map((section, index) => (
      <Fragment key={index}>
        <HideableAccordionItem section={section} hidden={false} />
      </Fragment>
    ))}
  </Accordion>
)

const AccordionSection = ({
  heading,
  sections,
  background = "#FBF5F0",
  centered,
  children,
  twoColumns,
  visibleRowsLimit
}: AccordionSectionProps) => {
  return (
    <GridWrapper background={background}>
      <Row justifyContent="center" justifyContentMobile="center">
        <Col
          className={cn({ "lg:text-center": centered })}
          grid={!twoColumns ? { xs: 12, sm: 12, md: 10, lg: 8, xl: 8 } : {}}
        >
          {heading && <h2 className="h2 mb-6 md:mb-10">{heading}</h2>}

          {!twoColumns ? (
            <SingleColumnAccordion sections={sections} />
          ) : (
            <TwoColumnsAccordion sections={sections} visibleRowsLimit={visibleRowsLimit} />
          )}

          <div className="mt-8">{children}</div>
        </Col>
      </Row>
    </GridWrapper>
  )
}

export default AccordionSection
